import React, { useEffect, useMemo, useState } from "react";
import { getConfig } from "../../../../../network/auth";
import axios from "axios";
import { baseUrl } from "../../../../../network/constants/constants";
import OtherServiceTable from "./components/otherServiceTable";
import { Col, Row, Spinner } from "react-bootstrap";
import SearchField from "../../../../customComponent/searchField/searchField";


const OtherServiceBooking = () => {
  const [otherServiceBooking, setOtherServiceBooking] = useState([]);
  const [loading, setLoading] = useState(false);


  const [searchValue, setSearchValue] = useState("");

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const config = useMemo(() => {
    return getConfig();
  }, []);

  const fetchOtherServiceBooking = () => {
    setLoading(true);
    axios
      .get(baseUrl + `superadmin/other-service-booking-history/`, config)
      .then((response) => {
        setOtherServiceBooking(response.data);
      })
      .catch((error) => {
        console.error("other service Booking Error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const formattedServiceBooking = otherServiceBooking?.map((booking) => ({
    ...booking,
    booked_at: booking.booked_at ? new Date(booking.booked_at).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true, 
    }) : "",
  }));
    
  const filteredBooking = formattedServiceBooking.filter((booking) =>
    Object.entries(booking).some(([key, value]) => {
      if (Array.isArray(value)) {
        return value.some((item) =>
          item.toString().toLowerCase().includes(searchValue.toLowerCase())
        );
      }
  
      if (typeof value === "boolean") {
        
        const stringValue =
          key === "is_paid"
            ? value
              ? "Paid"
              : "Pending"
            : key === "is_booked"
            ? value
              ? "Booked"
              : "Available"
            : "";
  
        return stringValue.toLowerCase().includes(searchValue.toLowerCase());
      }
  
      return (
        value &&
        value.toString().toLowerCase().includes(searchValue.toLowerCase())
      );
    })
  );
  
  
  const displayBooking = searchValue ? filteredBooking : otherServiceBooking;
  const alertwithIndex = displayBooking.map((alert, index) => ({
    ...alert,
    displayIndex: index + 1,
  }));
  useEffect(() => {
    fetchOtherServiceBooking();
  }, []);

  return (
    <div>
      {loading ? (
        <div className="loader-container">
          <Spinner className="spinner-loader" />
        </div>
      ) : (
        <>
          <Row className="mb-2">
            <Col>
            <SearchField searchValue={searchValue} handleSearchChange={handleSearchChange}/>
            </Col>
          </Row>
          <Row>
            <OtherServiceTable otherServiceBooking={alertwithIndex} />
          </Row>
        </>
      )}
    </div>
  );
};

export default OtherServiceBooking;
